import React from "react";
import Websitetoolcard from "../../globalcomponent/websitetoolcard";
import { Link } from "react-router-dom";

const WebsiteTools = () => {
  return (
    <div className="flex items-center justify-center mt-16 mx-2">
      <div>
        <div>
          <span
            className="text-3xl flex items-center justify-center text-yellow-500 font-semibold"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            Website tools
          </span>
          <div
            className="flex items-center justify-center flex-wrap gap-16"
            data-aos="fade-left"
            data-aos-duration="700"
          >
            <Link to="/charts/economic-calender">
              <Websitetoolcard
                img={"https://img.icons8.com/bubbles/100/null/calendar--v2.png"}
                title={"Economic Calendar"}
                des={
                  "Our regularly updated Economic Calendar covers major announcements and meetings. Sort the events according to importance, region or date and stay prepared"
                }
              />
            </Link>

            <Link to="/charts/live-price">
              <Websitetoolcard
                img={
                  "https://img.icons8.com/external-nawicon-outline-color-nawicon/80/null/external-profit-business-nawicon-outline-color-nawicon.png"
                }
                title={"Live rates"}
                des={
                  "Gain an immediate visual understanding of the everchanging market with live rates, reliably tracking the performance of hundreds of financial instruments for you."
                }
              />
            </Link>
          </div>
        </div>

        <div className="mt-16">
          <span
            className="text-3xl  flex items-center justify-center text-yellow-500 font-semibold"
            data-aos="fade-down"
            data-aos-duration="700"
          >
            Platform tools
          </span>
          <div
            className="flex items-center justify-center flex-wrap gap-16"
            data-aos="fade-right"
            data-aos-duration="700"
          >
            <Websitetoolcard
              img={
                "https://img.icons8.com/external-creatype-blue-field-colourcreatype/100/000000/external-arrow-arrows-creatype-blue-field-colourcreatype-44.png"
              }
              title={"Trading Signals"}
              des={
                "Want to know what other traders are thinking about a specific instrument? The Trading Sentiment tool will provide you with the relevant answer in one click."
              }
            />
            <Websitetoolcard
              img={
                "https://img.icons8.com/external-kiranshastry-lineal-color-kiranshastry/100/null/external-bar-chart-business-and-management-kiranshastry-lineal-color-kiranshastry.png"
              }
              title={"Live charts"}
              des={
                "Charts allow traders to identify market opportunities, plan their strategies and manage risks. Follow current market rates and make informed trading decisions."
              }
            />
          </div>
        </div>

        <div className="mt-16">
          <div
            className="flex items-center justify-center flex-wrap gap-16"
            data-aos="fade-left"
            data-aos-duration="700"
          >
            <Websitetoolcard
              img={
                "https://img.icons8.com/external-becris-lineal-color-becris/100/null/external-maths-data-science-becris-lineal-color-becris.png"
              }
              title={"Trading sentiment"}
              des={
                "Want to know what other traders are thinking about a specific instrument? The Trading Sentiment tool will provide you with the relevant answer in one click."
              }
            />
            <Websitetoolcard
              img={
                "https://img.icons8.com/external-phatplus-lineal-color-phatplus/100/null/external-line-chart-charts-diagrams-phatplus-lineal-color-phatplus-4.png"
              }
              title={"Indicators"}
              des={
                "Our technical indicators (provided by a leading third party) can be placed directly on the charts. Take your pick from dozens of choices and gain additional insight."
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsiteTools;
